import {
  Divider,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { ReactComponent as ImageIcon } from 'assets/icons/folderImage.svg';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UploadImagesData } from '../UploadMenu.helper';
import { FolderProps, filterByFolderImages } from './Folders.helper';
import { ImageContainer } from './ImageContainer';
import { ManageFolderMenu } from './ManageFolderMenu';

type UploadModalContentProps = {
  onClose: () => void;
  usersFolders: FolderProps[];
  uploadImages: UploadImagesData;
  createOnOpen?: boolean;
};

const UploadModalContent = ({ onClose, usersFolders, uploadImages, createOnOpen }: UploadModalContentProps) => {
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false });
  const [selectedFolder, setFolder] = useState<FolderProps>({
    value: '',
    label: t('sideMenu.imagesMenu.folders.allUploads'),
    icon: <ImageIcon />,
  });

  const [selectedImages, selectImages] = useState<string[]>([]);

  const selectFolder = useCallback((folder: FolderProps) => {
    setFolder(folder);
  }, []);

  // Get all folder images
  const folderImages = useMemo(
    () => filterByFolderImages(selectedFolder, uploadImages, usersFolders),
    [selectedFolder, uploadImages, usersFolders],
  );

  return (
    <ModalContent>
      <ModalHeader>{t('sideMenu.uploads')}</ModalHeader>
      <ModalCloseButton data-testid={'close-download-modal-button'} onClick={onClose} />
      <Divider />
      <ModalBody p={0}>
        <Grid
          h='80%'
          templateAreas={`"nav main" "nav footer"`}
          gridTemplateRows={'92% 1fr 0'}
          gridTemplateColumns={'25% 1fr'}
        >
          <ManageFolderMenu
            usersFolders={usersFolders}
            selectFolder={selectFolder}
            selectImages={selectImages}
            createOnOpen={createOnOpen}
            selectedFolder={selectedFolder}
            selectedImages={selectedImages}
          />
          <ImageContainer
            usersFolders={usersFolders}
            uploadImages={folderImages}
            selectedFolder={selectedFolder}
            selectFolder={selectFolder}
            selectedImages={selectedImages}
            selectImages={selectImages}
            closeModal={onClose}
          />
        </Grid>
      </ModalBody>
    </ModalContent>
  );
};

interface ManageFolderModalProps {
  isOpen: boolean;
  onClose: () => void;
  usersFolders: FolderProps[];
  uploadImages: UploadImagesData;
  createOnOpen?: boolean;
}
export const ManageFolderModal = ({
  isOpen = false,
  onClose = () => {},
  usersFolders,
  uploadImages,
  createOnOpen,
}: ManageFolderModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size='5xl'>
      <ModalOverlay />
      <UploadModalContent
        onClose={onClose}
        usersFolders={usersFolders}
        createOnOpen={createOnOpen}
        uploadImages={uploadImages}
      />
    </Modal>
  );
};
